import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful';
import type { TypeTechnologySkeleton } from './TypeTechnology';

export interface TypeBlockTechnologyBlocksFields {
    overline?: EntryFieldTypes.Symbol;
    headerText?: EntryFieldTypes.Symbol;
    paragraph?: EntryFieldTypes.Text;
    technologies?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeTechnologySkeleton>>;
}

export type TypeBlockTechnologyBlocksSkeleton = EntrySkeletonType<
    TypeBlockTechnologyBlocksFields,
    'blockTechnologyBlocks'
>;
export type TypeBlockTechnologyBlocks<
    Modifiers extends ChainModifiers,
    Locales extends LocaleCode = LocaleCode,
> = Entry<TypeBlockTechnologyBlocksSkeleton, Modifiers, Locales>;

export function isTypeBlockTechnologyBlocks<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
    entry: Entry<EntrySkeletonType, Modifiers, Locales>
): entry is TypeBlockTechnologyBlocks<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'blockTechnologyBlocks';
}
